import * as poolFactory from '../abis/poolFactory.json';
import * as tokenFaucet from '../abis/tokenFaucet.json';

export const config = {
    networkId: 97,
    poolFactoryAbi: poolFactory.default,
    poolFactoryAddress: "0xaD524FbAFe042543613576713886b807AEb41270",
    tokenFaucetAbi: tokenFaucet.default,
    tokenFaucetAddress: "0x58A77d051EAf555C236680048c8E34F4aC71698D",
}
